import { createRootRoute, createRoute, createRouter, Outlet } from '@tanstack/react-router'
import { NotFoundPage } from './routes/not-found-page'
import { ReportLinkPage } from './routes/report-link-page'

const rootRoute = createRootRoute({
  component: () => <Outlet />,
  notFoundComponent: NotFoundPage,
})

const linkRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/$linkToken',
  component: ReportLinkPage,
})

const notFoundRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '*',
  component: NotFoundPage,
})

export const routeTree = rootRoute.addChildren([linkRoute, notFoundRoute])

export const router = createRouter({ routeTree })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
